<template lang="pug">
  v-tooltip(top :color="popupColor")
    template(v-slot:activator="{on}")
      v-icon(v-on="on" :color="iconColor") {{icon}}
    span.whitespace-pre {{ message }}
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      required: false,
      default: "test"
    },
    icon: {
      type: String,
      required: false,
      default: "warning"
    },
    popupColor: {
      type: String,
      required: false,
      default: "red"
    },
    iconColor: {
      type: String,
      required: false,
      default: "warning"
    }
  }
};
</script>

<style scoped lang="stylus"></style>
